import LTR from "@brand-icons/global/qr-code/qr-code-ltr.svg";

import { iconFactory } from "../iconFactory";

export const QrCodeIcon = iconFactory("QrCodeIcon", LTR);
